export enum PremiumSource {
  PREMIUM_PAGE = 'Premium Page',
  BUNDLES_PDP = 'PDP Upsell',
  CART_UPSELL = 'Cart Upsell',
}
